/*
  Project: feag
  Author: schrittweiter GmbH
 */

import './modules/appHeight';
import './modules/hyphen';
import './modules/trigger';
import './modules/menu';
import './modules/lazy';
import './modules/wiki';
import './modules/parallax';
import './modules/scroll';
import './modules/tab';
import './modules/slider';
import './modules/gallery';
import './modules/count';
import './modules/map';
import './modules/megamenu';
import './modules/mobilemenu';
import './modules/download';
import './modules/videoLightbox';
import './modules/grid';
import './modules/loadmore';
import './modules/wissen';
import './modules/like';
import './modules/dashboard';
import './modules/intranet';
import decryptEmail from './modules/spamProtection';

window.spamProtection = decryptEmail;
